import { footerLinks, site } from "@/mocks/manga";

export default function Footer() {
  return (
    <footer className="w-full bg-background-800">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{site.name}</span>
            </div>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-background-100/70">
              {site.desc}，为每一位忍者同人爱好者提供畅快、免费、无删减的在线阅读体验。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-widest text-secondary-400">快速导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm text-background-100/80 transition-colors hover:text-secondary-400">
                    <i className="ri-arrow-right-s-line text-secondary-500"></i> {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-widest text-secondary-400">读者社区</h3>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-100/70">
              欢迎通过社区互动交流喜欢的火影同人漫画，分享你的追更心得与推荐作品。
            </p>
            <div className="mt-4 flex gap-2">
              {["ri-wechat-line", "ri-qq-line", "ri-weibo-line", "ri-bilibili-line"].map((icon) => (
                <span key={icon} className="flex h-9 w-9 items-center justify-center rounded-md bg-background-900 text-background-100/80 ring-1 ring-background-950/30 transition-colors hover:text-secondary-400">
                  <i className={icon}></i>
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-950/40 pt-6 sm:flex-row">
          <p className="text-xs text-background-100/60">© 2026 {site.name} · 仅供同人爱好交流，所有内容版权归原作者所有。</p>
          <p className="text-xs text-background-100/60">联系邮箱：contact@huoying-doujin.example.com</p>
        </div>
      </div>
    </footer>
  );
}